export default __webpack_public_path__ + "static/media/enterprise.020da819.png";